module.exports = __webpack_public_path__ + "img/ss-logo-high-res.bce19937.png";